import reducer, { actions } from './slice';
import * as asyncActions from './asyncActions';

export const organizationSubscriptionStore = {
  actions,
  asyncActions,
};

export default reducer;
